import { send_request } from '../Request';

export const getProjectInfoWithComponentId = componentId => {
  return send_request(
    `project-service/project/get_project_info_with_componentid/` + componentId,
    {},
    null,
    'GET'
  );
};

export const getProjectSessionWithSessionId = sessionId => {
  return send_request(`project-service/project-session/${sessionId}`, {}, null, 'GET');
};

export const getComponentSessionWithSessionIdAndComponentId = (sessionId, componentId) => {
  return send_request(
    `project-service/project-session/component_session/${sessionId}/${componentId}`,
    {},
    null,
    'GET'
  );
};

// BPMN Migration APIs
export const migrateProjectToBpmn = projectId => {
  return send_request(
    `project-service/project/migrate-to-bpmn/${projectId}`,
    {},
    null,
    'POST'
  );
};

export const previewBpmnMigration = projectId => {
  return send_request(
    `project-service/project/preview-bpmn-migration/${projectId}`,
    {},
    null,
    'GET'
  );
};

export const needsBpmnMigration = projectId => {
  return send_request(
    `project-service/project/needs-bpmn-migration/${projectId}`,
    {},
    null,
    'GET'
  );
};
